import { Gizmo } from '../../gizmos';
import aggregate from './aggregate';
import time from './time';
import age from './age';
import includes from './includes';
import len from './len';
import regex from './regex';
import gnov from './gnov';
import number from './number';

interface IParams {
  functionName: string;
  args: any[];
  context: {
    gizmo?: Gizmo;
  };
}

/**
 * Evaluate flux functions
 *
 * @param {string} functionName name of the function to be evaluated
 * @param {any[]} args function arguments
 * @param {any} context the context will contain necessary instance for the functions to calculate
 *  correctly a result, like the gizmoCallbacks
 *
 * @returns function result if the function is supported
 */
function functions({ functionName, args, context }: IParams): Promise<any> {
  return new Promise<any>(async resolve => {
    if (functionName === 'aggregate') {
      return resolve(
        aggregate({
          operation: args[0],
          elements: args[1],
          context,
        })
      );
    } else if (functionName === 'time') {
      return resolve(time(args[0]));
    } else if (functionName === 'age') {
      return resolve(age(args[0]));
    } else if (functionName === 'includes') {
      return resolve(includes(args[0], args[1]));
    } else if (functionName === 'len') {
      return resolve(len(args[0]));
    } else if (functionName === 'regex') {
      return resolve(regex(args[0], args[1]));
    } else if (functionName === 'gnov') {
      return resolve(gnov(args[0], args[1]));
    } else if (functionName === 'number') {
      return resolve(number(args[0]));
    }

    resolve(undefined);
  });
}

export default functions;
